import { useState } from "react";
import { Save } from "lucide-react";
import { Modal, Field } from "./common";
import { PROVINCES, districtsOf } from "../lib/trAddress";
import { ORIGINS } from "../lib/appt";

export function LeadFields({ form, setForm }) {
  const change = (e) => setForm((f) => ({ ...f, [e.target.name]: e.target.value }));
  return (
    <>
      <div className="form-grid">
        <Field label="Ad soyad *" name="lead-name" value={form.name} onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))} required />
        <Field label="Telefon" name="lead-phone" type="tel" value={form.phone} onChange={(e) => setForm((f) => ({ ...f, phone: e.target.value }))} />
        <Field label="E-posta" name="lead-email" type="email" value={form.email} onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))} />
        <label className="field">
          <span>İl</span>
          <select name="city" value={form.city} onChange={(e) => setForm((f) => ({ ...f, city: e.target.value, district: "" }))} data-testid="lead-city-select">
            <option value="">İl seçin</option>
            {PROVINCES.map((p) => <option key={p} value={p}>{p}</option>)}
          </select>
        </label>
        <label className="field">
          <span>İlçe</span>
          <select name="district" value={form.district} onChange={change} disabled={!form.city} data-testid="lead-district-select">
            <option value="">{form.city ? "İlçe seçin" : "Önce il seçin"}</option>
            {districtsOf(form.city).map((d) => <option key={d} value={d}>{d}</option>)}
          </select>
        </label>
        <label className="field">
          <span>Aday kaynağı</span>
          <select name="origin" value={form.origin || ""} onChange={change} data-testid="lead-origin-select">
            <option value="">Seçin</option>
            {ORIGINS.map((o) => <option key={o} value={o}>{o}</option>)}
          </select>
        </label>
        <Field label="Açık adres" name="lead-address" value={form.address} onChange={(e) => setForm((f) => ({ ...f, address: e.target.value }))} />
      </div>
      <label className="field full">
        <span>Not</span>
        <textarea rows="2" name="note" value={form.note} onChange={change} data-testid="lead-note-input" />
      </label>
    </>
  );
}

export const emptyLead = () => ({ name: "", phone: "", email: "", city: "", district: "", address: "", note: "", origin: "" });

export function LeadModal({ initial, onSave, onClose }) {
  const [form, setForm] = useState(() => ({ ...emptyLead(), ...(initial || {}) }));
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await onSave(form); } finally { setBusy(false); }
  };
  return (
    <Modal title={initial?.id ? `${initial.name} · düzenle` : "Yeni potansiyel müşteri adayı"} onClose={onClose}>
      <form onSubmit={submit} data-testid="lead-form">
        <LeadFields form={form} setForm={setForm} />
        <div className="modal-actions">
          <button type="button" className="outline-button" onClick={onClose} data-testid="lead-cancel-button">Vazgeç</button>
          <button type="submit" className="primary-button" disabled={busy} data-testid="lead-save-button"><Save size={15} /> Kaydet</button>
        </div>
      </form>
    </Modal>
  );
}
